import { useState, useEffect } from 'react';

import { TRACK } from '../constants/facebook/events';
import useLocationConfig from './locationConfig';
import fbc from '../helpers/facebookPixel';
import * as SCREENS from '../constants/facebook/screens';

export const useFacebookPixel = () => {
  const locationConfig = useLocationConfig(SCREENS);
  const [facebookPixel, setFacebookPixel] = useState();

  useEffect(() => {
    if (locationConfig) {
      const facebook = (tag, action = TRACK) => {
        if (locationConfig[tag]) {
          const tagValue = locationConfig[tag];
          if (typeof tagValue !== 'string') return;
          fbc(action, tagValue);
        }
      };
      setFacebookPixel(() => facebook);
    }
  }, [locationConfig]);

  return facebookPixel;
};
